export const titles = [
    {title: 'EQUIPMENT'},
    {title: 'USER'},
    {title: 'DAILYREPORT'},
    {title: 'PROJECTACTIVITIES'},
    {title: 'EMPLOYEE'},
    {title: 'TOWER'},
    {title: 'ACTIVITY'},
    {title: 'SUBCONTRACTOR'}
];